export const CLIPS = 'CLIPS';
export const EPISODES = 'EPISODES';



// WEBPACK FOOTER //
// ./src/show-page/constants/category-type.js